module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('orders', {
    attrs: {
      "headers": _vm.headers,
      "rows": _vm.rows,
      "status": _vm.status,
      "headers-mobile": _vm.headersMobile,
      "currentStatus": _vm.currentStatus
    },
    on: {
      "close-modal": _vm.closeModal,
      "change-tab": _vm.changeTab,
      "detail": _vm.orderDetail,
      "cancel": _vm.cancelOrder,
      "deposit": _vm.depositData
    }
  }), _vm._v(" "), _c('el-dialog', {
    staticClass: "warehouse-pickup-modal modal-cancel",
    attrs: {
      "visible": _vm.modal,
      "title": "Anular Pedido"
    },
    on: {
      "close": _vm.closeCancel
    }
  }, [_c('div', {
    staticClass: "wrapper-body-cancel"
  }, [_c('span', [_vm._v("¿Está seguro de anular el pedido?")])]), _vm._v(" "), _c('div', {
    staticClass: "d-flex align-center justify-center",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "ok-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.confirmationCancel
    }
  }, [_vm._v("Aceptar")])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6089d353","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/profile/orders/list.vue
// module id = 1125
// module chunks = 7